module.exports = __webpack_public_path__ + "static/RobotoMono-Italic-4806ab32fc8937f1520d3e0230ab67a6.woff";